import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Layout from './components/Layout';
import AIAssistant from './components/AIAssistant';
import InstallPrompt from './components/InstallPrompt';
import DashboardCentre from './pages/DashboardCentre';
import DashboardStagiaire from './pages/DashboardStagiaire';
import DashboardFormateur from './pages/DashboardFormateur';
import DashboardTuteur from './pages/DashboardTuteur';
import DashboardEntreprise from './pages/DashboardEntreprise';
import DashboardResponsable from './pages/DashboardResponsable';
import DashboardMoniteur from './pages/moniteur/DashboardMoniteur';
import AnnoncesEmploi from './pages/moniteur/AnnoncesEmploi';
import Documents from './pages/Documents';
import Planning from './pages/Planning';
import Progression from './pages/Progression';
import HeuresStage from './pages/HeuresStage';
import Profil from './pages/Profil';
import ProfilTuteur from './pages/ProfilTuteur';
import ProfilEntreprise from './pages/ProfilEntreprise';
import MesStructures from './pages/MesStructures';
import ProfilFormateur from './pages/ProfilFormateur';
import ProfilEvaluateur from './pages/ProfilEvaluateur';
import ProfilCentre from './pages/ProfilCentre';
import ProfilResponsable from './pages/ProfilResponsable';
import Notation from './pages/Notation';
import Presence from './pages/Presence';
import Competences from './pages/Competences';
import Notifications from './pages/Notifications';
import GestionStagiaires from './pages/GestionStagiaires';
import GestionCentres from './pages/GestionCentres';
import Appreciation from './pages/Appreciation';
import Analytics from './pages/Analytics';
import HistoriqueNotes from './pages/HistoriqueNotes';
import SuiviStagiaireEntreprise from './pages/SuiviStagiaireEntreprise';
import ValidationAutonomieEntreprise from './pages/ValidationAutonomieEntreprise';
import FicheStagiaireCentre from './pages/FicheStagiaireCentre';
import BilanMensuelEntreprise from './pages/BilanMensuelEntreprise';
import PresenceCentre from './pages/PresenceCentre';
import PresenceEntreprise from './pages/PresenceEntreprise';
import MentionsLegales from './pages/MentionsLegales';
import RGPD from './pages/RGPD';
import CharteUtilisation from './pages/CharteUtilisation';
import CharteModal from './components/CharteModal';
import ProceduresReclamation from './pages/ProceduresReclamation';
import ValidationAutonomieStagiaire from './pages/ValidationAutonomieStagiaire';
import RecapitulatifAutonomies from './pages/RecapitulatifAutonomies';
import ListeStagiaires from './pages/ListeStagiaires';
import AnciensStagiaires from './pages/AnciensStagiaires';
import Qualiopi from './pages/Qualiopi';
import MaCharteFormateur from './pages/MaCharteFormateur';
import AdministratifFormateurs from './pages/AdministratifFormateurs';
import ReglementInterieur from './pages/ReglementInterieur';
import LivretAccueil from './pages/LivretAccueil';
import LivretBase from './pages/LivretBase';
import PresentationCentre from './pages/PresentationCentre';
import ConseilPerfectionnement from './pages/ConseilPerfectionnement';
import AmeliorationContinue from './pages/AmeliorationContinue';
import MesReclamations from './pages/MesReclamations';
import ListeTuteurs from './pages/ListeTuteurs';
import ListeRP from './pages/ListeRP';
import ListeEntreprises from './pages/ListeEntreprises';
import CarnetsNotes from './pages/CarnetsNotes';
import CarnetGeneral from './pages/CarnetGeneral';
import BulletinNotes from './pages/BulletinNotes';
import GestionDemandesAbsence from './components/GestionDemandesAbsence';
import ResponsableStagiaires from './pages/ResponsableStagiaires';
import ResponsableFormateurs from './pages/ResponsableFormateurs';
import ResponsableTuteurs from './pages/ResponsableTuteurs';
import ResponsableEntreprises from './pages/ResponsableEntreprises';
import ResponsablePresences from './pages/ResponsablePresences';
import ResponsableAnalytics from './pages/ResponsableAnalytics';
import CRMPage from './pages/CRMPage';
import SatisfactionPage from './pages/SatisfactionPage';
import RelancesPage from './pages/RelancesPage';
import ExportsPage from './pages/ExportsPage';
import ImportPage from './pages/ImportPage';
import QuestionnairePage from './pages/QuestionnairePage';
import MoniteursPage from './pages/entreprise/MoniteursPage';
import GestionFormateurs from './pages/GestionFormateurs';
import FOADPage from './pages/FOADPage';
import QuestionBankPage from './pages/QuestionBankPage';
import KahootHostPage from './pages/KahootHostPage';
import KahootPlayerPage from './pages/KahootPlayerPage';
import FOADApprenantPage from './pages/FOADApprenantPage';
import LettresMissionPage from './pages/LettresMissionPage';
import InscriptionCandidat from './pages/InscriptionCandidat';
import InscriptionMoniteur from './pages/InscriptionAncienMoniteur';
import DashboardCandidat from './pages/DashboardCandidat';
import PaiementSucces from './pages/PaiementSucces';
import GestionCandidats from './pages/GestionCandidats';
import FicheCandidatCentre from './pages/FicheCandidatCentre';
import FormationDistance from './pages/FormationDistance';
import NewsletterList from './pages/Newsletter/NewsletterList';
import NewsletterEditor from './pages/Newsletter/NewsletterEditor';
import PIFEditor from './pages/PIFEditor';
import PIFCandidat from './pages/PIFCandidat';
import GrilleEPMSP from './pages/GrilleEPMSP';
import Evaluateurs from './pages/Evaluateurs';
import AgendaFormation from './pages/AgendaFormation';
import RapportJournalier from './pages/RapportJournalier';
import InscriptionEvaluateur from './pages/InscriptionEvaluateur';
import DashboardEvaluateur from './pages/DashboardEvaluateur';
import GuideBC from './pages/GuideBC';
import { Toaster } from './components/ui/sonner';
import PushNotificationManager from './components/PushNotificationManager';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
// Always use relative /api for API calls - works on both preview and deployed custom domains
const API = '/api';

axios.defaults.baseURL = API;

// === PROTECTION: max 4 requêtes simultanées + timeout ===
let activeConcurrent = 0;
const MAX_CONCURRENT = 4;
const pendingQueue = [];

axios.defaults.timeout = 20000;

axios.interceptors.request.use((config) => {
  if (activeConcurrent < MAX_CONCURRENT) {
    activeConcurrent++;
    return config;
  }
  return new Promise((resolve) => {
    pendingQueue.push(() => { activeConcurrent++; resolve(config); });
  });
});

const onRequestDone = () => {
  activeConcurrent = Math.max(0, activeConcurrent - 1);
  if (pendingQueue.length > 0) {
    const next = pendingQueue.shift();
    next();
  }
};

axios.interceptors.response.use(
  (response) => { onRequestDone(); return response; },
  (error) => { onRequestDone(); return Promise.reject(error); }
);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [originalUser, setOriginalUser] = useState(null); // Pour le mode Super Admin
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async () => {
    try {
      const response = await axios.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setOriginalUser(null);
    setIsImpersonating(false);
  };

  // Mode Super Admin - "Voir comme" un autre utilisateur
  const handleImpersonate = async (targetUser) => {
    try {
      // Sauvegarder le token original du centre avant d'impersonner
      if (!isImpersonating) {
        setOriginalUser(user);
        localStorage.setItem('original_token', localStorage.getItem('token'));
      }
      // Obtenir un vrai token pour l'utilisateur cible
      const response = await axios.post('/auth/impersonate', {
        user_id: targetUser.user_id,
        role: targetUser.role
      });
      const { access_token, user: userData } = response.data;
      localStorage.setItem('token', access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
      setUser({ ...userData, role: targetUser.role });
      setIsImpersonating(true);
    } catch (error) {
      // Fallback : mode impersonation sans token (ancien comportement)
      if (!isImpersonating) {
        setOriginalUser(user);
      }
      setUser(targetUser);
      setIsImpersonating(true);
    }
  };

  // Revenir au compte Centre
  const handleExitImpersonate = () => {
    const originalToken = localStorage.getItem('original_token');
    if (originalToken) {
      localStorage.setItem('token', originalToken);
      axios.defaults.headers.common['Authorization'] = `Bearer ${originalToken}`;
      localStorage.removeItem('original_token');
    }
    if (originalUser) {
      setUser(originalUser);
      setOriginalUser(null);
      setIsImpersonating(false);
    }
  };

  // Switch de rôle multi-rôle
  const handleSwitchRole = async (newRole) => {
    try {
      const response = await axios.post('/auth/switch-role', { role: newRole });
      const { access_token, user: userData } = response.data;
      localStorage.setItem('token', access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
      setUser(userData);
    } catch (error) {
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-lg text-slate-600">Chargement...</div>
      </div>
    );
  }

  const ProtectedRoute = ({ children }) => {
    if (!user) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  const getDashboard = () => {
    switch (user?.role) {
      case 'centre':
        return <DashboardCentre user={user} onImpersonate={handleImpersonate} />;
      case 'stagiaire':
        return <DashboardStagiaire user={user} />;
      case 'formateur':
        return <DashboardFormateur user={user} />;
      case 'tuteur':
        return <DashboardTuteur user={user} />;
      case 'entreprise':
        return <DashboardEntreprise user={user} />;
      case 'responsable_pedagogique':
        return <DashboardResponsable user={user} />;
      case 'moniteur_vnm':
        return <DashboardMoniteur user={user} />;
      case 'candidat':
        return <DashboardCandidat user={user} />;
      case 'evaluateur':
        return <DashboardEvaluateur user={user} />;
      default:
        return <div>Rôle non reconnu</div>;
    }
  };

  const handleCharteAccepted = () => {
    setUser(prev => ({ ...prev, charte_acceptee: true }));
  };

  const showCharteModal = user && !user.charte_acceptee && user.role !== 'candidat';

  return (
    <div className="App">
      {showCharteModal && <CharteModal onAccept={handleCharteAccepted} />}
      {user && <InstallPrompt />}
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" replace />}
          />
          <Route
            path="/forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            path="/reset-password"
            element={<ResetPassword />}
          />
          <Route path="/demo/guide-bc1-bc2" element={<Navigate to="/guide-bc1-bc2" replace />} />
          {/* Route publique inscription candidat */}
          <Route
            path="/inscription-candidat"
            element={<InscriptionCandidat />}
          />
          {/* Route publique inscription moniteur */}
          <Route
            path="/inscription-moniteur"
            element={<InscriptionMoniteur />}
          />
          {/* Route publique inscription evaluateur */}
          <Route
            path="/inscription-evaluateur"
            element={<InscriptionEvaluateur />}
          />
          {/* Route paiement succès candidat */}
          <Route
            path="/espace-candidat/paiement-succes"
            element={
              <ProtectedRoute>
                <PaiementSucces />
              </ProtectedRoute>
            }
          />
          {/* Route espace candidat */}
          <Route
            path="/espace-candidat"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <DashboardCandidat user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  {getDashboard()}
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Documents user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/planning"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Planning user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/progression"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Progression user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/heures-stage"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <HeuresStage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Profil user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil-centre"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ProfilCentre user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notation"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Notation user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/historique-notes"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <HistoriqueNotes user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/presence"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Presence user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/competences"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Competences user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Notifications user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/gestion-stagiaires"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <GestionStagiaires user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil-tuteur"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  {user?.role === 'tuteur' ? <ProfilTuteur user={user} /> : <Profil user={user} />}
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil-formateur"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  {user?.role === 'formateur' ? <ProfilFormateur user={user} /> : <Profil user={user} />}
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil-evaluateur"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  {user?.role === 'evaluateur' ? <ProfilEvaluateur user={user} /> : <Profil user={user} />}
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil-entreprise"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  {user?.role === 'entreprise' ? <ProfilEntreprise user={user} /> : <Profil user={user} />}
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mes-structures"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <MesStructures user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/appreciation"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Appreciation user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Analytics user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/suivi-stagiaire"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <SuiviStagiaireEntreprise user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/validation-autonomie"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ValidationAutonomieEntreprise user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiche-stagiaire"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <FicheStagiaireCentre user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bilan-mensuel"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <BilanMensuelEntreprise user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/presence-centre"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <PresenceCentre user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/validation-autonomie-stagiaire"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ValidationAutonomieStagiaire user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/recapitulatif-autonomies"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <RecapitulatifAutonomies user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/liste-stagiaires"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ListeStagiaires user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/anciens-stagiaires"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <AnciensStagiaires />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/guide-bc1-bc2"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <GuideBC />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/qualiopi"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Qualiopi />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ma-charte"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <MaCharteFormateur />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/livret-accueil"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <LivretAccueil user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/presentation"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <PresentationCentre />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/jury-plenier"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <PresentationCentre doc="jury-plenier" />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/livret-base"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <LivretBase user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/reglement-interieur"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ReglementInterieur user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/formateurs"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <AdministratifFormateurs />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/conseil-perfectionnement"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ConseilPerfectionnement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administratif/amelioration-continue"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <AmeliorationContinue />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reclamations"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <MesReclamations user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/liste-tuteurs"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ListeTuteurs user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/liste-rp"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ListeRP user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/liste-entreprises"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ListeEntreprises user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/demandes-absence"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <GestionDemandesAbsence user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/presence-entreprise"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <PresenceEntreprise user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/carnets-notes"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <CarnetsNotes user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/carnet-general"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <CarnetGeneral user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bulletin-notes"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <BulletinNotes user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Nouvelles routes pour Gestion Centres */}
          <Route
            path="/gestion-centres"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <GestionCentres user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Routes pour Responsable Pédagogique */}
          <Route
            path="/profil-responsable"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ProfilResponsable user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/responsable/stagiaires"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ResponsableStagiaires user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/responsable/formateurs"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ResponsableFormateurs user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/responsable/tuteurs"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ResponsableTuteurs user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/responsable/entreprises"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ResponsableEntreprises user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/responsable/presences"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ResponsablePresences user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/responsable/analytics"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ResponsableAnalytics user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/responsable/fiche-stagiaire"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <FicheStagiaireCentre user={user} readOnly={true} backUrl="/responsable/stagiaires" />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route CRM */}
          <Route
            path="/crm"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <CRMPage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route FOAD */}
          <Route
            path="/foad"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <FOADPage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Banque de Questions */}
          <Route
            path="/question-bank"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <QuestionBankPage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Kahoot Host (formateur) */}
          <Route
            path="/foad-kahoot"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <KahootHostPage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Kahoot Player (public - eleves scannent QR) */}
          <Route path="/foad-kahoot-play" element={<KahootPlayerPage />} />
          {/* Route Vue Apprenant FOAD */}
          <Route
            path="/mes-formations"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <FOADApprenantPage user={user} isImpersonating={isImpersonating} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Satisfaction & Insertion */}
          <Route
            path="/satisfaction"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <SatisfactionPage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Relances Automatiques */}
          <Route
            path="/relances"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <RelancesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Grille EPMSP */}
          <Route
            path="/grille-epmsp"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <GrilleEPMSP user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Évaluateurs */}
          <Route
            path="/evaluateurs"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <Evaluateurs user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Exports */}
          <Route
            path="/exports"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ExportsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Import */}
          <Route
            path="/import"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <ImportPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Gestion Formateurs pour Centre */}
          <Route
            path="/gestion-formateurs"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <GestionFormateurs user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Gestion Candidats pour Centre */}
          <Route
            path="/gestion-candidats"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <GestionCandidats user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Fiche Candidat détaillée pour Centre */}
          <Route
            path="/fiche-candidat"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <FicheCandidatCentre user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* PIF Candidat - Création/Edition par le Centre */}
          <Route
            path="/pif-candidat"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <PIFCandidat user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Lettres de Mission */}
          <Route
            path="/lettres-mission"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <LettresMissionPage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Questionnaire (public avec token) */}
          <Route
            path="/questionnaire/:questionnaireId"
            element={<QuestionnairePage />}
          />
          {/* Route Moniteurs pour Entreprises */}
          <Route
            path="/moniteurs"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <MoniteursPage user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Route Annonces Emploi pour Moniteurs VNM */}
          <Route
            path="/annonces-emploi"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <AnnoncesEmploi user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/formation-distance"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <FormationDistance />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Pages légales (accessibles sans authentification) */}
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/rgpd" element={<RGPD />} />
          <Route path="/charte" element={<CharteUtilisation />} />
          <Route path="/procedures-reclamation" element={<ProceduresReclamation />} />
          <Route
            path="/newsletters"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <NewsletterList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/newsletters/:id"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <NewsletterEditor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/agenda-formation"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <AgendaFormation />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/rapport-journalier"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout} isImpersonating={isImpersonating} onExitImpersonate={handleExitImpersonate} originalUser={originalUser} onSwitchRole={handleSwitchRole}>
                  <RapportJournalier user={user} />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      {user && <AIAssistant user={user} />}
      {user && <PushNotificationManager user={user} />}
    </div>
  );
}

export default App;